import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  constructor(private http: HttpClient) { }

  getFundingSourceBillingTrips(queryParam: any) {
    const params = new HttpParams({ fromObject: queryParam });
    return this.http.get(urls.API_URL + urls.ADJUST_BILLING_TRIPS, { params })
      .pipe(catchError(errorHandl));
  }

  getFundingSourceTripById(id: any) {
    return this.http.get(urls.API_URL + urls.ADJUST_BILLING_TRIPS + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  getFsReportTrips(queryParam: any) {
    const params = new HttpParams({ fromObject: queryParam });
    return this.http.get(urls.API_URL + urls.FS_RAW_REPORT, { params })
      .pipe(catchError(errorHandl));
  }

}
